import { GridContainer } from 'libs/ui';
import { Calls } from 'grids/calls/calls';

export const CallsWrapper = (props) => {
  return (
    <GridContainer>
      <Calls {...props} />
    </GridContainer>
  );
};
